/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import moment from "moment";
import store from "../../store/index";
import createCraIssue from "../CraManagement/createCraIssue.vue";
import jwt_decode from "jwt-decode";

export default {
  name: "TaskQuestionLayout",
   components: {
    createCraIssue
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_Service_URL,
      craScheduleId: "",
      visitname:"",
      sitecode:"",
      siteid:"",
      status:"",
      tasks: [],
      selectedTask: null,
      loading: false,
      roleprivileges: [],
      showcreateIssueModal: false,
      selectedStudyId: "",
    selectedSiteId: "",
    };
  },

  async mounted() {
    this.craScheduleId = this.$route.query.craScheduleId || "";
    this.visitname = this.$route.query.visitname || "";
    this.sitecode = this.$route.query.sitecode || "";
    this.siteid = this.$route.query.siteid || "";
    console.log("this.visitname",this.visitname);
    console.log("this.sitecode",this.sitecode);
    
    if (this.craScheduleId) {
      await this.loadTasks();
    }
    await this.setroleprivileges();

  },

  methods: {
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
    async loadTasks() {
      try {
        this.loading = true;
        let idtoken = store.getters.getIdToken;
        let studyId = store.getters.getStudyIs;
        const res = await axios.get(
          `${this.baseUrl}/forms/cra/getcrascheduledchecklist`,
          {
            params: {
              craScheduleId: this.craScheduleId,
              studyId: studyId
            },
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const data = res.data;

        this.tasks = (data.checklists || []).map(checklist => ({
          id: checklist.checklistId,
          name: checklist.title,
          questions: checklist.questions.map(q => ({
            id: q.questionId,
            text: q.text,
            answer: q.response || "",
            comment: q.comments || "",
            status: q.status || ""
          }))
        }));

        if (this.tasks.length) {
          this.selectTask(this.tasks[0]);
        }
      } catch (error) {
        console.error("Failed to load CRA checklist", error);
      } finally {
        this.loading = false;
      }
    },

    selectTask(task) {
      this.selectedTask = {
        ...task,
        questions: task.questions.map(q => ({ ...q }))
      };
    },

    async saveQuestion(question) {
      try {
        const idtoken = store.getters.getIdToken;
        let studyId = store.getters.getStudyIs;

        const payload = {
          studyId: studyId,
          craScheduleId: this.craScheduleId,
          checklistId: this.selectedTask.id,
          questionId: question.id,

          question: {
            response: question.answer,
            comments: question.comment,
            status: question.status
          }
        };

        await axios.put(
          `${this.baseUrl}/forms/cra/updatecrachecklistquestion`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );

        alert("Question saved successfully");
        this.loadTasks();

      } catch (error) {
        console.error("Save question failed", error);
        alert("Failed to save question");
      }
    },
  OpenIssue(question) {
  this.selectedStudyId =
    this.$route.query.studyId || store.getters.getStudyId;

  this.selectedSiteId =
    this.$route.query.siteId || store.getters.getSiteId;

  this.showcreateIssueModal = true;
},



    async saveAllQuestions() {
      try {
        const idtoken = store.getters.getIdToken;
        let studyId = store.getters.getStudyIs;

        const payload = {
            
          // lastModifiedUserEmail: store.getters.getUserEmail,
          // lastModifiedUserId: store.getters.getUserId,
          // lastModifiedAt: new Date().toISOString(),
          studyId: studyId,
          craScheduleId: this.craScheduleId,
          checklistId: this.selectedTask.id,

          questions: this.selectedTask.questions.map(q => ({
            questionId: q.id,
            response: q.answer,
            comments: q.comment,
            status: q.status
          }))
        };

        await axios.put(
          `${this.baseUrl}/forms/cra/updatecraentirechecklist`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );

        alert("Task saved successfully");
        this.loadTasks();

      } catch (error) {
        console.error("Save entire checklist failed", error);
        alert("Failed to save task");
      }
    },
    async onclosed() {
      // this.$router.push(`/crascheduellist`);
        this.$router.back();
    },

  }
};
